import { action, observable } from "mobx";

import Store from "app/stores/Store";
import StatsStore from "./StatsStore";

class VideoShareStore extends Store {
    @observable sharing: boolean = false;
    @observable time: ?number;

    @action.bound
    share() {
        this.sharing = true;
        this.time = null;
        StatsStore.shareVideo();
    }

    @action.bound
    shareAt(time: number) {
        this.sharing = true;
        this.time = time;
        StatsStore.shareVideo();
    }

    @action.bound
    close() {
        this.sharing = false;
    }
}

export default new VideoShareStore();



// WEBPACK FOOTER //
// ./src/app/stores/VideoShareStore.js